var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInEditorMode)?_c('dr-wrapper',_vm._g(_vm._b({},'dr-wrapper',_vm.$props,false),_vm.wrapOn),[_c('div',{attrs:{"id":_vm.model.$ID}})]):(_vm.isVisible)?_c('div',{class:_vm.evaluateClasses(_vm.classes),attrs:{"id":_vm.model.$ID}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }